// Entry point. Boots into the main menu; user picks plane and either plays
// a normal match or watches the 60-second judges' demo (a docu-tour + a
// spectator-mode match with full LLM dialogue and voice).

import { GameApp } from './core/GameApp';
import { MainMenu, type MainMenuChoice } from './ui/MainMenu';
import { DemoTour } from './ui/DemoTour';

const host = document.getElementById('app');
const boot = document.getElementById('boot');
if (!host) throw new Error('#app missing');

declare global {
  interface Window { __game?: GameApp }
}

setTimeout(() => boot?.classList.add('hide'), 400);

const menu = new MainMenu((choice: MainMenuChoice) => {
  menu.destroy();
  if (choice.mode === 'play') {
    launchGame(choice);
  } else {
    launchDemo(choice);
  }
});

function launchGame(choice: MainMenuChoice, demoMode = false): void {
  const app = new GameApp(host!, { shape: choice.shape, color: choice.color });
  window.__game = app;
  app.start();
  if (demoMode) {
    // Spectator: AI keeps fighting; no player input attempt.
    // (Player plane still exists but we lock the camera onto an AI.)
    setTimeout(() => {
      const ai = app.planes.find((e) => e.controller && e.plane.alive);
      if (ai) app.camera.follow(ai.plane, 0, true);
    }, 100);
  }
}

function launchDemo(choice: MainMenuChoice): void {
  const tour = new DemoTour({
    onComplete: () => {
      // After 45s slides finish + 15s spectator game already running.
      // Nothing else to do; tour overlay self-removes.
    },
    onSlideEnd: () => {
      // Slides ended at ~45s; spawn the spectator game live underneath the
      // fading overlay so judges see the cut-through.
      launchGame(choice, /*demoMode*/ true);
    },
    onSkip: () => {
      launchGame(choice, /*demoMode*/ false);
    },
  });
  tour.start();
}

console.log('[Paper Wings] menu boot OK');
